import { render } from "./MerchantUser.vue?vue&type=template&id=35481206&scoped=true&ts=true"
import script from "./MerchantUser.vue?vue&type=script&lang=ts"
export * from "./MerchantUser.vue?vue&type=script&lang=ts"

import "./MerchantUser.vue?vue&type=style&index=0&id=35481206&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35481206"]])

export default __exports__